module.exports = class AreasTableCtrl
  $onInit: ->
    @updateTable = @updateTable.bind(@)

  updateTable: ->
    @onRefresh()

  displayAreaCoordinates: (area) ->
    "#{area.lat}, #{area.lng}"
